/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
} from './PalReauthCaseManager';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
} from './PalReauthSubmissionStatus';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
} from './PalReauthSubmissionStatusInfo';
import type { PalReauthSubmissionTimingState } from './PalReauthSubmissionTimingState';
import {
    PalReauthSubmissionTimingStateFromJSON,
    PalReauthSubmissionTimingStateFromJSONTyped,
    PalReauthSubmissionTimingStateToJSON,
} from './PalReauthSubmissionTimingState';

/**
 * 
 * @export
 * @interface PalReauthSubmission
 */
export interface PalReauthSubmission {
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmission
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmission
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmission
     */
    pal_submission_id: string;
    /**
     * 
     * @type {PalReauthSubmissionStatus}
     * @memberof PalReauthSubmission
     */
    status: PalReauthSubmissionStatus;
    /**
     * 
     * @type {PalReauthSubmissionStatusInfo}
     * @memberof PalReauthSubmission
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     * @type {PalReauthSubmissionStatusInfo}
     * @memberof PalReauthSubmission
     */
    previous_status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmission
     */
    external_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PalReauthSubmission
     */
    next_review_date?: Date | null;
    /**
     * 
     * @type {PalReauthSubmissionTimingState}
     * @memberof PalReauthSubmission
     */
    timing_state: PalReauthSubmissionTimingState;
    /**
     * 
     * @type {boolean}
     * @memberof PalReauthSubmission
     */
    can_revert_status: boolean;
    /**
     * 
     * @type {PalReauthCaseManager}
     * @memberof PalReauthSubmission
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     * @type {Date}
     * @memberof PalReauthSubmission
     */
    date_created: Date;
}

/**
 * Check if a given object implements the PalReauthSubmission interface.
 */
export function instanceOfPalReauthSubmission(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "pal_submission_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "timing_state" in value;
    isInstance = isInstance && "can_revert_status" in value;
    isInstance = isInstance && "date_created" in value;

    return isInstance;
}

export function PalReauthSubmissionFromJSON(json: any): PalReauthSubmission {
    return PalReauthSubmissionFromJSONTyped(json, false);
}

export function PalReauthSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'status': PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': !exists(json, 'status_info') ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': !exists(json, 'previous_status_info') ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'next_review_date': !exists(json, 'next_review_date') ? undefined : (json['next_review_date'] === null ? null : new Date(json['next_review_date'])),
        'timing_state': PalReauthSubmissionTimingStateFromJSON(json['timing_state']),
        'can_revert_status': json['can_revert_status'],
        'case_manager': !exists(json, 'case_manager') ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'date_created': (new Date(json['date_created'])),
    };
}

export function PalReauthSubmissionToJSON(value?: PalReauthSubmission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'pal_submission_id': value.pal_submission_id,
        'status': PalReauthSubmissionStatusToJSON(value.status),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value.status_info),
        'previous_status_info': PalReauthSubmissionStatusInfoToJSON(value.previous_status_info),
        'external_id': value.external_id,
        'next_review_date': value.next_review_date === undefined ? undefined : (value.next_review_date === null ? null : value.next_review_date.toISOString().substring(0,10)),
        'timing_state': PalReauthSubmissionTimingStateToJSON(value.timing_state),
        'can_revert_status': value.can_revert_status,
        'case_manager': PalReauthCaseManagerToJSON(value.case_manager),
        'date_created': (value.date_created.toISOString()),
    };
}

